module.exports = __webpack_public_path__ + "img/bg2.16324cb6.jpg";